import { render, staticRenderFns } from "./Crecordervideo.vue?vue&type=template&id=b8778c18&scoped=true&"
import script from "./Crecordervideo.vue?vue&type=script&lang=js&"
export * from "./Crecordervideo.vue?vue&type=script&lang=js&"
import style0 from "./Crecordervideo.vue?vue&type=style&index=0&id=b8778c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8778c18",
  null
  
)

export default component.exports